import * as tslib_1 from "tslib";
import * as account from '../actions/account';
var initialState = {
    error: null,
    resetting: false,
    resetLinkValid: false,
    validationComplete: false,
    language: null,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case account.FORGOT:
        case account.RESET:
            return tslib_1.__assign({}, state, { resetting: true, error: null });
        case account.FORGOT_SUCCESS:
        case account.RESET_SUCCESS:
            return tslib_1.__assign({}, state, { resetting: false });
        case account.FORGOT_FAILED:
        case account.RESET_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, resetting: false });
        case account.FORGOT_CLEAR:
        case account.RESET_CLEAR:
            return tslib_1.__assign({}, state, { error: null });
        case account.VALIDATE_RESET_LINK_SUCCESS:
            return tslib_1.__assign({}, state, { resetLinkValid: action.payload, validationComplete: true });
        case account.VALIDATE_RESET_LINK_FAILED:
            return tslib_1.__assign({}, state, { resetLinkValid: false, validationComplete: true, error: action.payload });
        case account.USER_GET_LANGUAGE_SUCCESS:
            return tslib_1.__assign({}, state, { language: action.payload });
        default:
            return state;
    }
}
export var isResetting = function (state) { return state.resetting; };
export var getError = function (state) { return state.error; };
export var isResetLinkValid = function (state) { return state.resetLinkValid; };
export var isValidationCompleted = function (state) { return state.validationComplete; };
export var getLanguage = function (state) { return state.language; };
